<template>
  <div class="home">
    <section>
      <h1 class="text-5xl text-gray-800 pt-6 text-center mb-6">{{ $t("Today's Deals") }}:</h1>
      <div
        v-for="(r, index) in restaurants"
        :key="index"
        class="mx-4 rounded-lg bg-white pt-4 pb-8 shadow-lg px-6 mb-6"
      >
        <h2 class="text-xl mb-2">{{ r.name }}</h2>
        <p class="text-xl mb-2">{{ r.line1 }}</p>
        <p class="text-xl">{{ r.line2 }}</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      restaurants: [
        { name: 'Enes Restaurant', line1: '%10 discount today!', line2: 'Claim yours' },
        { name: 'Pius Restaurant', line1: 'Buy 6 wings and get a free drink!', line2: 'Valid this week only' },
        { name: 'Enes Restaurant', line1: '%10 discount today!', line2: 'Claim yours' },
        { name: 'Pius Restaurant', line1: 'Buy 6 wings and get a free drink!', line2: 'Valid this week only' },
      ],
    };
  },
};
</script>
<style lang="scss">
.cards-container {
  height: 650px;
  .card {
    width: 90%;
    @media (min-width: 640px) {
      width: 80%;
    }
    @media (min-width: 1024px) {
      width: 46%;
    }
  }
}
</style>
